import { SkillCard } from '../atoms/SkillCard';

/** Semi-transparent overlay that pauses the game and prompts skill selection. */
export function LevelUpOverlay({ skills, onChoose }) {
  return (
    <div className="levelup-overlay">
      <h2>Level Up!</h2>
      <p>Choose a skill</p>
      <div className="skill-choices">
        {skills.map(skill => (
          <SkillCard key={skill.id} skill={skill} onChoose={onChoose} />
        ))}
      </div>
    </div>
  );
}
